export default __webpack_public_path__ + "static/media/640_private03-en-mobile.2b5cb4d3.png";